import { c as _c } from "react/compiler-runtime";
type CountdownTimerProps = {
  current: number;
  start: number;
};
const CountdownTimer = t0 => {
  const $ = _c(2);
  const {
    current,
    start
  } = t0;
  if (start < current || current <= 0 || start <= 0) {
    return null;
  }
  let t1;
  if ($[0] !== current) {
    t1 = <div className="flex justify-center items-center rounded-full bg-black/35 w-[76px] h-[76px]"><p className="text-display-2 text-quinary fp-text">{current}</p></div>;
    $[0] = current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CountdownTimer;